import { useFlags } from 'launchdarkly-react-client-sdk';

import PatientOverviewTabV1, {
  PatientOverviewTabV1Props,
} from './PatientOverviewTabV1';
import PatientOverviewTabV2, {
  PatientOverviewTabV2Props,
} from './PatientOverviewTabV2';

// Forwarded whole to whichever view the flag picks, so it carries both views' props.
type OverviewTabProps = PatientOverviewTabV1Props & PatientOverviewTabV2Props;

// Resolves the Overview tab to the Mai chat layout (V2) when the mai-chat-panel
// flag is on, otherwise the existing layout. Keeping this decision here lets
// PatientTabsMap point at a single Overview component and keeps the flag next to
// the two views it chooses between. When mai-chat-panel is retired, delete this
// switcher and point the map straight at the surviving view.
const PatientOverviewTabSwitcher = (props: OverviewTabProps) => {
  const { maiChatPanel: isMaiChatEnabled } = useFlags<LDFlags>();

  return isMaiChatEnabled ? (
    <PatientOverviewTabV2 {...props} />
  ) : (
    <PatientOverviewTabV1 {...props} />
  );
};

export default PatientOverviewTabSwitcher;
